(function () {


class AlignmentPlugin {
    static defaultOptions = {
        context: false,
        items: ['left', 'center', 'right', 'justify'],
        icons: {
            left: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H4C3.44772 7 3 6.55228 3 6ZM3 12C3 11.4477 3.44772 11 4 11H14C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13H4C3.44772 13 3 12.5523 3 12ZM3 18C3 17.4477 3.44772 17 4 17H18C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19H4C3.44772 19 3 18.5523 3 18Z"/></svg>',
            right: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H4C3.44772 7 3 6.55228 3 6ZM9 12C9 11.4477 9.44772 11 10 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H10C9.44772 13 9 12.5523 9 12ZM5 18C5 17.4477 5.44772 17 6 17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H6C5.44772 19 5 18.5523 5 18Z"/></svg>',
            center: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H4C3.44772 7 3 6.55228 3 6ZM7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12ZM5 18C5 17.4477 5.44772 17 6 17H18C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18Z"/></svg>',
            justify: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 6C3 5.44772 3.44772 5 4 5H20C20.5523 5 21 5.44772 21 6C21 6.55228 20.5523 7 20 7H4C3.44772 7 3 6.55228 3 6ZM3 12C3 11.4477 3.44772 11 4 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H4C3.44772 13 3 12.5523 3 12ZM3 18C3 17.4477 3.44772 17 4 17H20C20.5523 17 21 17.4477 21 18C21 18.5523 20.5523 19 20 19H4C3.44772 19 3 18.5523 3 18Z"/></svg>'
        }
    };

    static defaultLang = {
        en: {
            alignment: {
                alignment: 'Alignment',
                left: 'Left',
                center: 'Center',
                right: 'Right',
                justify: 'Justify',
            }
        }
    };

    constructor(app, options = {}) {
        this.app = app;
        this.options = options;
    }

    start() {
        const button = {
            icon: this.options.icons.left,
            title: '## alignment.alignment ##',
            command: 'alignment.open',
            position: {
                after: 'format'
            },
            blocks: {
                all: 'editable'
            }
        };

        this.app.toolbar.add('alignment', button);

        if (this.options.context) {
            this.app.context.add('alignment', button);
        }
    }

    open(params = {}, { button, el } = {}) {
        const trigger = button || el;
        const currentAlign = this.get();
        const items = {};

        for (const item of this.options.items) {
            items[item] = {
                command: 'alignment.set',
                title: `## alignment.${item} ##`,
                active: currentAlign === item,
                icon: this.options.icons[item],
                params: { name: item }
            };
        }

        this.app.dropdown.create('alignment', { items });
        this.app.dropdown.open(trigger);
    }

    get() {
        const blocks = this.app.blocks.get({ editable: true });

        if (blocks.length > 1) {
            return this._getMultipleAlign(blocks);
        }

        return this._getInstanceAlign(blocks[0] || this.app.block.get());
    }

    set(params = {}) {
        this.app.dropdown.close();

        const blocks = this.app.blocks.get({ editable: true });

        if (blocks.length > 1) {
            blocks.forEach((block) => this._setInstanceAlign(block, params));
            return;
        }

        this._setInstanceAlign(blocks[0] || this.app.block.get(), params);
    }

    _setInstanceAlign(block, params) {
        if (!block) return;

        block.setStyles({ 'text-align': '' });
        this._setAlign(block, params);
    }

    _setAlign(block, params) {
        const dir = this.app.getOption('dir') || 'ltr';
        const name = params.name;

        if ((dir === 'ltr' && name !== 'left') || (dir === 'rtl' && name !== 'right')) {
            block.setStyles({ 'text-align': name });
        }
    }

    _getMultipleAlign(blocks) {
        const align = Object.fromEntries(this.options.items.map((key) => [key, 0]));
        const size = blocks.length;

        for (const block of blocks) {
            const key = this._getElementAlign(block.getEl());
            if (Object.hasOwn(align, key)) {
                align[key]++;
            }
        }

        for (const [key, value] of Object.entries(align)) {
            if (value === size) {
                return key;
            }
        }

        const empty = Object.values(align).filter((value) => value === 0).length;
        if (empty === Object.keys(align).length) {
            return this._getDefaultAlign();
        }

        return false;
    }

    _getInstanceAlign(block) {
        if (!block) return;

        const align = this._getElementAlign(block.getEl());
        return align || this._getDefaultAlign();
    }

    _getElementAlign(el) {
        if (!el) return '';
        return el.style.textAlign || '';
    }

    _getDefaultAlign() {
        const dir = this.app.getOption('dir') || 'ltr';
        return dir === 'rtl' ? 'right' : 'left';
    }
}

Redactor.addPlugin('alignment', AlignmentPlugin);


})(Redactor);
